import { render, staticRenderFns } from "./Seguros.vue?vue&type=template&id=36a3966f&"
import script from "./Seguros.vue?vue&type=script&lang=js&"
export * from "./Seguros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports